class ProductCaracteristics1 {
  constructor(container) {
    this.container = container;
    this.blur = null;
    this.init();
  }

  init() {
    this.initScrollAnimation();
  }

  initScrollAnimation() {
    this.blur = this.container.querySelector('.product-caracteristics-1__blur');

    if (!this.blur) return;

    this.handleScroll = this.handleScroll.bind(this);

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: Array.from({ length: 101 }, (_, i) => i / 100)
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          this.handleScroll();
        } else {
          window.removeEventListener('scroll', this.handleScroll);
        }
      });
    }, observerOptions);

    this.observer.observe(this.container);
  }

  handleScroll() {
    const rect = this.container.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    const totalHeight = rect.height;
    const scrollProgress = Math.max(0, Math.min(1, visibleHeight / totalHeight));

    const scale = 0.6 + (scrollProgress * 0.8);
    const opacity = 0.2 + (scrollProgress * 0.6);
    const translateY = (1 - scrollProgress) * 100;

    if (this.blur) {
      this.blur.style.transform = `translateX(-50%) scale(${scale}) translateY(${translateY}px)`;
      this.blur.style.opacity = opacity;
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }

    window.removeEventListener('scroll', this.handleScroll);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="product-caracteristics-1"]');
  sections.forEach(section => {
    new ProductCaracteristics1(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-section-type="product-caracteristics-1"]')) {
    new ProductCaracteristics1(event.target);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('[data-section-type="product-caracteristics-1"]');
  if (section && section.swiperInstance) {
    section.swiperInstance.destroy();
  }
});
